<div class="external-login-container">
    <p>Redirecting to login, please wait...</p>
</div>
